import _ from 'lodash';
import { setGridFieldsToStorage } from '../helpers';
import { setGridSortToStorage } from '../helpers';
const actions = {
    INIT_GRID_API: 'INIT_GRID_API',
    UPDATE_GRID_API: 'UPDATE_GRID_API',
    UPDATE_GRID_FIELDS: 'UPDATE_GRID_FIELDS',
    UPDATE_GRID_DATA: 'UPDATE_GRID_DATA',
    RESET_GRID: 'RESET_GRID',
    SET_ACTIVE_GRID_KEY: 'SET_ACTIVE_GRID_KEY',
};

const initData = {
    api: {
        key: null,
        path: null,
        page: 1,
        limit: 50,
        start: 0,
        query: undefined,
        sort_field: undefined,
        sort_order: undefined,
        checkedItems: [],
        filter: [],
        destroyOnUnmount: true,
    },
    params: {
        fields: null,
        total: null,
        options: {},
        t: () => {},
        filter: { onChange: () => {} },
        sort: { onChange: () => {} },
        pagination: {},
        onChangeFields: () => {},
        title: null,
    },
    update: false,
    custom: false,
    result: null,
};

/* selectors */
export const getGridData = (grid, gridKey) => {
    const { api, params, result, update, custom } = grid[gridKey] || initData;
    return { api, params, result, update, custom };
};

/* updaters */
const updateApi = (prevApi, nextApi) => {
    const { field, order, ...rest } = nextApi;
    const api = { ...prevApi, ...rest };

    if (nextApi.query) {
        api.page = prevApi.query === nextApi.query ? api.page : 1;
    }

    if (field) {
        api.sort_field = field || undefined;
        api.sort_order = order || undefined;
        /** for CRM API **/
        api.sort = order
            ? [
                  {
                      property: field,
                      direction: order.toUpperCase(),
                  },
              ]
            : [{ property: '', direction: '' }];
        /** end **/
    }

    api.start = ((api.page || prevApi.page) - 1) * api.limit;

    return api;
};

const updateParams = (prevParams, nextParams, api) => {
    const params = { ...prevParams, ...nextParams };
    // EXPERIMENTIVE, REWORK IF SOMETHING BREAKS (it should fix issue with not correct pagination numbers on total change, when it looks like 21 - 2 (of 2))
    // const { limit, page } = api; // OLD

    // NEW
    const { limit } = api;
    let { page } = api;

    const startFrom = (page - 1) * limit + 1;
    const { total } = nextParams;
    if (startFrom > total) {
        page = 1;
    }
    // NEW
    // EXPERIMENTIVE, REWORK IF SOMETHING BREAKS

    params.pagination.data = { limit, page, total: nextParams.total };
    params.filter = { ...params.filter, defaultValue: api.query };
    params.sort = {
        ...params.sort,
        field: api.sort_field,
        order: api.sort_order,
    };

    // console.log({api});

    return params;
};

/* reducer */
export default function secondReducer(state = {}, action) {
    if (action.type in actions) {
        const { type, gridKey, gridFieldsKey, withoutFieldsCache, withoutSortCache, gridFieldsSortKey, ...rest } = action;
        const { api, params, result } = rest;
        const prevGrid = state[gridKey] || initData;

        const gridWithSameFieldsKey = Object.keys(state).filter(key => {
            const grid = state[key];
            // make sure that key is not equal to current gridKey
            if (grid && grid.gridFieldsKey && grid.gridFieldsKey === gridFieldsKey && gridKey !== key) {
                return key;
            }
        });

        switch (type) {
            case actions.INIT_GRID_API: {
                const grid = { api: updateApi(prevGrid.api, api), gridFieldsKey };
                grid.params = prevGrid.params.fields
                    ? prevGrid.params
                    : { ...prevGrid.params, ...params };
                // eslint-disable-next-line max-len
                grid.params.pagination.data =
                    prevGrid.params.pagination.data || params.pagination.data;

                return {
                    ...state,
                    gridKey,
                    [gridKey]: { ...prevGrid, ...rest, ...grid },
                };
            }

            case actions.UPDATE_GRID_API: {
                const grid = { api: updateApi(prevGrid.api, api) };

                const newState = { ...state, [gridKey]: { ...prevGrid, ...rest, ...grid } };

                if (gridFieldsSortKey && !withoutSortCache) {
                    setGridSortToStorage(gridFieldsSortKey, _.get(newState[gridKey], 'api.sort'));
                }
                // console.log({gridFieldsKey, sort: _.get(newState[gridKey], 'api.sort')});
                return newState;
            }

            case actions.UPDATE_GRID_FIELDS: {
                const grid = { params: { ...prevGrid.params, ...params } };
                const newState = { ...state, [gridKey]: { ...prevGrid, ...rest, ...grid } };

                if (!withoutFieldsCache && gridWithSameFieldsKey.length) {
                    const newFields = grid && grid.params && grid.params.fields;
                    if (newFields) {
                        gridWithSameFieldsKey.forEach(key => {
                            newState[key] = {...newState[key], params: {
                                ...newState[key].params,
                                fields: newFields
                            }};
                        });
                    }
                }

                // setGridFieldsToStorage(gridKey, _.get(newState[gridKey], 'params.fields'));

                // gridFieldsKey is used to properly set fields data in localStore (cell sizes for example)
                // while gridKey could contain "extra" key => the same grid could have different cell sizes
                // for example: gridState_customer_appeals_person_6707567.88873 => gridState_customer_appeals_
                if (!withoutFieldsCache) {
                    setGridFieldsToStorage(gridFieldsKey, _.get(newState[gridKey], 'params.fields'));
                }
                return newState;
            }

            case actions.UPDATE_GRID_DATA: {
                const grid = {
                    result,
                    params: updateParams(prevGrid.params, params, prevGrid.api),
                };

                return { ...state, [gridKey]: { ...prevGrid, ...rest, ...grid } };
            }

            case actions.RESET_GRID: {
                return {
                    ...state,
                    // gridKey: null,
                    [gridKey]: null,
                };
            }

            case actions.SET_ACTIVE_GRID_KEY: {
                return {
                    ...state,
                    gridKey,
                };
            }

            default:
                return state;
        }
    }

    return state;
}

/* action creators */
export const init = ({ api, params, gridKey, update, custom, gridFieldsKey, withoutFieldsCache, withoutSortCache, gridFieldsSortKey }) => ({
    type: actions.INIT_GRID_API,
    gridKey,
    api,
    params,
    update,
    custom,
    gridFieldsKey,
    withoutFieldsCache,
    withoutSortCache,
    gridFieldsSortKey,
});

// eslint-disable-next-line max-len
export const setApi = (data, gridKey, gridFieldsKey, withoutFieldsCache, withoutSortCache, gridFieldsSortKey) => ({
    type: actions.UPDATE_GRID_API,
    gridKey,
    gridFieldsKey,
    withoutFieldsCache,
    withoutSortCache,
    gridFieldsSortKey,
    api: data,
    update: true,
});

// gridFieldsKey is used to properly set fields data in localStore (cell sizes for example)
// while gridKey could contain "extra" key => the same grid could have different cell sizes
// for example: gridState_customer_appeals_person_6707567.88873 => gridState_customer_appeals_
// fieldsLsCacheKey needed to properly handle GridWithFilters case
// when there are all grids with the same key, but only different "extra"
// gridState_grid_with_filters => gridState_grid_with_filters_appeal
export const setFields = (fields, gridKey, gridFieldsKey, withoutFieldsCache, withoutSortCache, gridFieldsSortKey) => ({
    type: actions.UPDATE_GRID_FIELDS,
    gridKey,
    gridFieldsKey,
    withoutFieldsCache,
    withoutSortCache,
    gridFieldsSortKey,
    params: { fields },
    update: false,
    custom: true,
});

export const setData = (result, gridKey) => ({
    type: actions.UPDATE_GRID_DATA,
    gridKey,
    result,
    params: { total: result.total },
    update: false,
});

export const setActiveGridKey = (gridKey) => {
    return { type: actions.SET_ACTIVE_GRID_KEY, gridKey };
};

export const reset = (gridKey) => {
    localStorage.removeItem(gridKey);
    localStorage.removeItem(`config_map_${gridKey}`);
    return { type: actions.RESET_GRID, gridKey };
};
